import { LegalShell, H2, P, UL } from "./LegalShell";

export default function Cookies() {
  return (
    <LegalShell
      testid="page-legal-cookies"
      overline="Legal"
      title="Cookie Notice"
      updated="Current"
      seoDesc="TWORAY Ltd Cookie Notice — strictly-necessary cookies by default, analytics only with consent."
    >
      <P>This notice explains how we use cookies and similar technologies. Non-essential cookies are blocked until you give consent through our cookie banner (Consent Mode, denied by default).</P>

      <H2>1. Strictly-necessary cookies</H2>
      <P>These are required for the website and secure admin area to function (e.g. session and authentication cookies). They do not require consent and cannot be switched off.</P>

      <H2>2. Analytics cookies (consent required)</H2>
      <P>If you accept, we use analytics cookies (Google Analytics) to understand how the site is used and improve it. These load only after you click "Accept all". You can change your mind at any time by clearing site data or contacting us.</P>

      <H2>3. Advertising cookies</H2>
      <P>We do not currently run advertising cookies. If this changes, they will remain off until you consent.</P>

      <H2>4. Managing your choices</H2>
      <UL items={[
        "Use the cookie banner to accept or reject non-essential cookies.",
        "Reject non-essential keeps only strictly-necessary cookies active.",
        "You can also control cookies through your browser settings.",
      ]} />
    </LegalShell>
  );
}
